import { APIS_ENDPOINTS } from '../../SERVICE-CONSTANTS'
import http from '../../HttpConfig'

const apiCaller_legalrequestfiles = APIS_ENDPOINTS.legalrequestfiles

export const request_getlegalrequestfiles = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    apiCaller_legalrequestfiles.getalllegalrequestfiles +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_create = async ({
  file,
  fileName,
  legalRequestTypeId,
}: {
  fileName: string
  file: string
  legalRequestTypeId: number
}) => {
  var formData = new FormData()
  formData.append('file', file)
  formData.append('fileName', fileName)
  formData.append('legalRequestTypeId', legalRequestTypeId.toString())

  return http.post(apiCaller_legalrequestfiles.create, formData)
}

export const request_edit = async ({
  file,
  fileName,
  legalRequestTypeId,
  id,
}: {
  id: number
  fileName: string
  file: string
  legalRequestTypeId: number
}) => {
  var formData = new FormData()
  formData.append('id', id.toString())
  if (file) {
    formData.append('file', file)
  }
  formData.append('fileName', fileName)
  formData.append('legalRequestTypeId', legalRequestTypeId.toString())

  return http.post(apiCaller_legalrequestfiles.edit, formData)
}

export const request_getalllegalrequesttype = async () => {
  return http.get(apiCaller_legalrequestfiles.getalllegalrequesttype)
}

export const request_delete = async (id: number) => {
  return http.delete(apiCaller_legalrequestfiles.delete + `?id=${id}`)
}
